import { createFileRoute } from '@tanstack/react-router';
import { Proches } from '../proches/Proches';
import { prochesUrlSchema } from '../proches/url';

export const Route = createFileRoute('/proches')({
  validateSearch: prochesUrlSchema,
  component: PageProches,
});

function PageProches() {
  return <Proches recherche={Route.useSearch()} />;
}
